import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

type Crumb = { name: string; href?: string };

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { isDark } = useTheme();

  return (
    <div className={`border-b transition-colors duration-300 ${isDark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-100'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <nav className="flex items-center gap-2 text-sm flex-wrap">
          {items.map((crumb, i) => {
            const isLast = i === items.length - 1;
            const sep = (
              <span key={`sep-${i}`} className={isDark ? 'text-gray-700' : 'text-gray-300'}>/</span>
            );
            const node = isLast || !crumb.href ? (
              <span key={`crumb-${i}`} className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                {crumb.name}
              </span>
            ) : (
              <Link
                key={`crumb-${i}`}
                to={crumb.href}
                className={isDark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'}
              >
                {crumb.name}
              </Link>
            );
            return i === 0 ? node : [sep, node];
          })}
        </nav>
      </div>
    </div>
  );
}
